import React, { useState } from "react";
import axios from "axios";
import { readToken, readUser } from "utils/session";

export const PUBLIC_LOGO = "https://hypertraceio.s3.eu-north-1.amazonaws.com/fav.png";
export const PUBLIC_ASSET_ICON = "https://hypertraceio.s3.eu-north-1.amazonaws.com/sedan3.png";

function storedPicture() {
  const user = readUser();
  return user?.custpicpath || user?.userpropicpath || "";
}

function rememberPicture(url) {
  const user = readUser();
  if (!user || !url) return;
  user.custpicpath = url;
  user.userpropicpath = url;
  localStorage.setItem("userInfo", JSON.stringify(user));
}

export default function AccountImage({ className, alt = "Account" }) {
  const [src, setSrc] = useState(storedPicture() || PUBLIC_LOGO);
  const [triedRefresh, setTriedRefresh] = useState(false);

  const refresh = () => {
    if (triedRefresh) {
      setSrc(PUBLIC_LOGO);
      return;
    }
    setTriedRefresh(true);
    const token = readToken();
    if (!token) {
      setSrc(PUBLIC_LOGO);
      return;
    }
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/account/banner`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const url = response.data?.url;
        if (!url) {
          setSrc(PUBLIC_LOGO);
          return;
        }
        rememberPicture(url);
        setSrc(url);
      })
      .catch(() => setSrc(PUBLIC_LOGO));
  };

  return <img src={src} alt={alt} className={className} onError={refresh} />;
}
